
    var riot = require('riot')
    //src: starling/src/tags/node-perspective-annotations.html
riot.tag2('node-perspective-annotations',
  '<div ref="annotationContainer"> </div>',
  'node-perspective-annotations node-perspective-annotation svg,[data-is="node-perspective-annotations"] node-perspective-annotation svg{ display: none; } node-perspective-annotations .annotation-container.active,[data-is="node-perspective-annotations"] .annotation-container.active{ position: relative; padding: 8px 10px; color: white; max-width: 300px; width: max-content; border-radius: 3px; z-index: 9999; pointer-events: all; transform: unset !important; box-sizing: border-box; margin-left: 20px; margin-bottom: 4px; } node-perspective-annotations .annotation svg,[data-is="node-perspective-annotations"] .annotation svg{ display: none; }',
  'ref="main" show="{this.showPerspectivePoint() || this.getNodePerspectives().length}"', function(opts) {
'use strict';

var _this = this;

var _perspectivesUi = require('lib/perspectives-ui');

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.canvas = this.parent.canvas;
this.nodePerspectives = [];
this.node = this.canvas.store.getNode(this.parent.id);
this.nodeTag = this.parent;
if (!this.opts.dummy) {
  this.canvas.nodePerspectiveAnnotationsTag[this.parent.id] = this;
}
this.on('update', function () {
  _this.pointPerspective = _this.getPointPerspective();
});

this.showPerspectivePoint = function () {
  return _this.pointPerspective && !_this.pointPerspective.hidden;
};

this.getAnnotationTags = function () {
  if (_this.tags['node-perspective-annotation'] && _this.tags['node-perspective-annotation'].length) {
    return _this.tags['node-perspective-annotation'];
  } else if (_this.tags['node-perspective-annotation']) {
    return [_this.tags['node-perspective-annotation']];
  }
  return [];
};

this.getPointPerspective = function () {
  return _store_instance2.default.getPerspectives().find(function (p) {
    return p.pointNodeUUID == _this.node.id && !p.hidden;
  });
};

this._fetchNodePerspectives = function () {
  var pers = _perspectivesUi.pui.getNodePerspectives(_this.node);
  _this.nodePerspectives = [];
  for (var _iterator = pers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var p = _ref;

    _this.nodePerspectives.push({ perspective: p });
  }
};

this.getNodePerspectives = function () {
  return _this.nodePerspectives;
};

this.getShuttledAnnotation = function (perspectiveId) {
  if (!perspectiveId) {
    console.error('missing perspectiveId');
  }
  if (!(_this.refs && _this.refs.main)) return;
  return _this.refs.main.querySelector('.annotation[data-id="' + perspectiveId + '"]');
};

this.removeAnnotation = function (perspectiveId) {
  var element = _this.getShuttledAnnotation(perspectiveId);
  if (element) {
    element.parentNode.removeChild(element);
  }
};
/*
    this.getNextAnnotationPosition = (perspectiveId) => {
      const dots = this.getDots();
      let nextY = 20;
      const curr = dots.find(d => d.id == perspectiveId);
      for (const dot of dots) {
        if (dot.id == perspectiveId) {
          continue;
        }
        if (dot.showAnnotation() && dot.positioned) {
          const box = dot.getAnnotationBoundingBox();
          if (box) {
            console.log('adding TO',curr.getAnnotation(),dot.getAnnotation(),nextY,'h',box.height);
            nextY = nextY + box.height + 4;
          }
        }
      }
      return {y: nextY}
    }
*/
this._fetchNodePerspectives();
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-perspective-annotations')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-perspective-annotations.html
// module id = 650
// module chunks = 0